import Handlebars from 'handlebars';

const JS_PREFIX = 'js-dynamic-view';
//const CSS_PREFIX = 'dynamic-view';

const dynamicViews = (() => {
  const self = {
    dom: {
      views: null
    },
    historySupported: !!(window.history && window.history.pushState),
    views: [],
    constructViews() {
      self.dom.views.forEach(viewElement => {
        const dom = {
          el: viewElement,
          content: viewElement.querySelector('.' + JS_PREFIX + '__content')
        }

        const template = Handlebars.compile(viewElement.querySelector('.' + JS_PREFIX + '__template').textContent);

        const baseUrl = viewElement.dataset.baseUrl || '';

        let slashedBaseUrl = baseUrl;

        if(baseUrl && baseUrl[baseUrl.length - 1] !== '/') {
          slashedBaseUrl += '/';
        }

        const view = {
          params: viewElement.dataset.params,
          id: viewElement.dataset.viewId,
          baseUrl: slashedBaseUrl,
          showLoader() {
            dom.el.setAttribute('aria-busy', true);
          },
          hideLoader() {
            dom.el.setAttribute('aria-busy', false);
            dom.el.classList.add('is-loaded');

            //remove is-loaded status after x seconds
            setTimeout(() => {
              dom.el.classList.remove('is-loaded');
            }, '10000');
          },
          scrollToLoader(params = {}) {
            dom.el.scrollIntoView(params)
          },
          /**
           * Update url using history API
           *
           * @param {string} url - New url. Use relative path ('test/path') if you want to use `this.baseUrl` as base
           */
          replaceUrl(url = '') {
            if(!self.historySupported) {
              return;
            }

            // Append to baseUrl if relative path
            if(url.indexOf('/') !== 0) {
              url = this.baseUrl + url;
            }

            window.history.replaceState({}, '', url);
          },
          /**
           * Update page title
           *
           * @param {string} titlePart - New beginning for the title
           * @param {string} [separator] - replace content before the last occurance of the separator
           */
          replaceTitle(titlePart, separator) {
            if(!separator){
              document.title = titlePart;
              return;
            }
            const separatorIndex = document.title.lastIndexOf(separator);
            const separatorFound = separatorIndex >= 0;
            document.title = separatorFound ? titlePart + document.title.substring(separatorIndex) : titlePart + separator + document.title;
          },
          render(data) {
            this.hideLoader();
            // Replace all, slow and loses all listeners. Enough for now, but keep eye on `lit-html` (or something similar) if they get server side rendering and hydration
            dom.content.innerHTML = template(data);
          }
        };
        self.views.push(view);
      });
    },
    getView(viewId) {
      return self.views.find(view => view.id === viewId);
    }
  };

  (function init() {
    self.dom.views = document.querySelectorAll('.' + JS_PREFIX);

    if(!self.dom.views.length) {
      return;
    }

    self.constructViews();
  })();

  return {
    getView: self.getView.bind(self)
  }
})();

export default dynamicViews;
export { dynamicViews };
